import React, { Fragment } from "react";
import { Table } from "react-bootstrap";
import "../../assets/css/scss/component/table/_playerTable.scss"
import { baseball_index, BASEBALL_PLAYER_STATISTICS_SIDEBAR, BASEBALL_STATISTICS, BASEBALL_STATISTICS_COLUMN, BASEBALL_TEAM_STATISTICS_SIDEBAR } from "../../constant/match"
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../interfaces/redux";

export default function PlayerTable(props: any) {
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLang = globalState?.selectedLang || "";
    console.log("player table >", props)
    const getTable = (selectedDropdown: number, game: number = 1) => {
        let constantData: any;
        let tableConstant: any;
        let data: any;
        if (game === baseball_index) {
            if (selectedDropdown === 0) {
                constantData = BASEBALL_STATISTICS["batting"][selectedLang];
                tableConstant = BASEBALL_STATISTICS_COLUMN['batting'];
                data = props?.data?.batting;
            } else if (selectedDropdown === 1) {
                constantData = BASEBALL_STATISTICS["pitcher"][selectedLang];
                tableConstant = BASEBALL_STATISTICS_COLUMN['pitcher'];
                data = props?.data?.pitcher;
            } else if (selectedDropdown === 2) {
                constantData = BASEBALL_STATISTICS["fielding"][selectedLang];
                tableConstant = BASEBALL_STATISTICS_COLUMN['fielding'];
                data = props?.data?.fielding;
            }
            if (props?.isTeam) {
                constantData = [...BASEBALL_TEAM_STATISTICS_SIDEBAR[selectedLang], ...constantData]
            } else {
                constantData = [...BASEBALL_PLAYER_STATISTICS_SIDEBAR[selectedLang], ...constantData]
            }
        }
        if (data) {
            if (!tableConstant) {
                const tableHeader = (
                    <Fragment>
                        <thead>
                            <tr>
                                {constantData?.map((item: { name: any }, index: any) => {
                                    //<th scope="col">{item.name}</th>
                                    return (<th className="text-uppercase">{item.name}</th>)
                                })}
                            </tr>
                        </thead>
                    </Fragment>
                );
                let tableBody = (
                    <Fragment>
                        <tbody>
                            {data?.map((item: { [x: string]: React.ReactNode; }, index: number) => {
                                return (
                                    <tr>
                                        {constantData?.map((itemChild: any, index: any) => {
                                            return (
                                                <td>
                                                    {item[itemChild.field_name] !== null ? item[itemChild.field_name] : "-"}
                                                </td>
                                            )
                                        })}
                                    </tr>)
                            })}
                        </tbody>
                    </Fragment>
                )
                return <Table striped bordered hover responsive className={props?.isTeam ? "team-table" : ""}>{tableHeader}{tableBody}</Table>;
            }
            let tables: JSX.Element[] = [];
            let displayedNumber: number = 0;
            let maxLoopValue: number = 0;
            // eslint-disable-next-line
            Object.keys(tableConstant).map((tData, tIndex) => {
                maxLoopValue = (tableConstant[tData]['number']) ? displayedNumber + parseInt(tableConstant[tData]['number']) : constantData.length;
                if (maxLoopValue <= constantData.length) {
                    const tableHeader = (
                        <Fragment>
                            <thead>
                                <tr>
                                    {constantData?.map((item: { name: any, title: string }, index: any) => {
                                        if ((displayedNumber <= index && index <= maxLoopValue) || index === 0 || index === 1) {
                                            return (
                                                <th className="text-uppercase" title={item.title ? item.title : ""}>{item.name}</th>
                                            )
                                        }
                                    })}
                                </tr>
                            </thead>
                        </Fragment>
                    );
                    let tableBody = (
                        <Fragment>
                            <tbody>
                                {data?.map((item: { [x: string]: React.ReactNode; }, index: number) => {
                                    return (
                                        <tr>
                                            {constantData?.map((itemChild: any, index: any) => {
                                                if ((displayedNumber <= index && index <= maxLoopValue) || index === 0 || index === 1) {
                                                    return (<td>{item[itemChild.field_name] !== null ? item[itemChild.field_name] : "-"}</td>)
                                                }
                                            })}
                                        </tr>)
                                })}
                            </tbody>
                        </Fragment>
                    )
                    tables.push(
                        <Fragment>
                            {/* <h4>
                                {tableConstant[tData]['name'][selectedLang]}
                            </h4> */}

                            <div className="player-table-title theme-light-white">
                                <h3 className="mb-0 bold">{tableConstant[tData]['name'][selectedLang]}</h3>
                            </div>
                            {/* table point-table */}
                            <Table striped bordered hover responsive>
                                {tableHeader}{tableBody}
                            </Table>
                        </Fragment>);
                    displayedNumber = maxLoopValue + 1;
                }
            })
            return tables;
        }
    }
    return (
        <div className="player-main-table" key={props?.selectStatistics.toString()}>
            {
                props?.data ?
                    getTable(props?.selectStatistics)
                    : null
            }
            {/* <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>SEASON</th>
                        <th>TEAM</th>
                        <th>GP</th>
                        <th>AB</th>
                        <th>R</th>
                        <th>H</th>
                        <th>2B</th>
                        <th>3B</th>
                        <th>HR</th>
                        <th>RBI</th>
                        <th>BB</th>
                        <th>HBP</th>
                        <th>SO</th>
                        <th>SB</th>
                        <th>CS</th>
                        <th>AVG</th>
                        <th>OBP</th>
                        <th>SLG</th>
                        <th>OPS</th>
                        <th>WAR</th>
                        <th>AVG</th>
                        <th>OBP</th>
                        <th>SLG</th>
                        <th>OPS</th>
                        <th>WAR</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>2018</td>
                        <td>WSH</td>
                        <td>116</td>
                        <td>414</td>
                        <td>77</td>
                        <td>121</td>
                        <td>25</td>
                        <td>1</td>
                        <td>22</td>
                        <td>70</td>
                        <td>79</td>
                        <td>0</td>
                        <td>99</td>
                        <td>5</td>
                        <td>2</td>
                        <td>.292</td>
                        <td>.406</td>
                        <td>.517</td>
                        <td>.923</td>
                        <td>3.0</td>
                        <td>.292</td>
                        <td>.406</td>
                        <td>.517</td>
                        <td>.923</td>
                        <td>3.0</td>
                    </tr>
                    <tr>
                        <td>2019</td>
                        <td>WSH</td>
                        <td>150</td>
                        <td>542</td>
                        <td>110</td>
                        <td>153</td>
                        <td>32</td>
                        <td>5</td>
                        <td>34</td>
                        <td>110</td>
                        <td>108</td>
                        <td>3</td>
                        <td>132</td>
                        <td>12</td>
                        <td>1</td>
                        <td>.282</td>
                        <td>.401</td>
                        <td>.548</td>
                        <td>.949</td>
                        <td>4.7</td>
                        <td>.292</td>
                        <td>.406</td>
                        <td>.517</td>
                        <td>.923</td>
                        <td>3.0</td>
                    </tr>
                    <tr>
                        <td>2019</td>
                        <td>WSH</td>
                        <td>150</td>
                        <td>542</td>
                        <td>110</td>
                        <td>153</td>
                        <td>32</td>
                        <td>5</td>
                        <td>34</td>
                        <td>110</td>
                        <td>108</td>
                        <td>3</td>
                        <td>132</td>
                        <td>12</td>
                        <td>1</td>
                        <td>.282</td>
                        <td>.401</td>
                        <td>.548</td>
                        <td>.949</td>
                        <td>4.7</td>
                        <td>.292</td>
                        <td>.406</td>
                        <td>.517</td>
                        <td>.923</td>
                        <td>3.0</td>
                    </tr>
                    <tr>
                        <td>2019</td>
                        <td>WSH</td>
                        <td>150</td>
                        <td>542</td>
                        <td>110</td>
                        <td>153</td>
                        <td>32</td>
                        <td>5</td>
                        <td>34</td>
                        <td>110</td>
                        <td>108</td>
                        <td>3</td>
                        <td>132</td>
                        <td>12</td>
                        <td>1</td>
                        <td>.282</td>
                        <td>.401</td>
                        <td>.548</td>
                        <td>.949</td>
                        <td>4.7</td>
                        <td>.292</td>
                        <td>.406</td>
                        <td>.517</td>
                        <td>.923</td>
                        <td>3.0</td>
                    </tr>
                    <tr>
                        <td>2019</td>
                        <td>WSH</td>
                        <td>150</td>
                        <td>542</td>
                        <td>110</td>
                        <td>153</td>
                        <td>32</td>
                        <td>5</td>
                        <td>34</td>
                        <td>110</td>
                        <td>108</td>
                        <td>3</td>
                        <td>132</td>
                        <td>12</td>
                        <td>1</td>
                        <td>.282</td>
                        <td>.401</td>
                        <td>.548</td>
                        <td>.949</td>
                        <td>4.7</td>
                        <td>.292</td>
                        <td>.406</td>
                        <td>.517</td>
                        <td>.923</td>
                        <td>3.0</td>
                    </tr>
                    <tr>
                        <td>Career</td>
                        <td>464</td>
                        <td>1612</td>
                        <td>337</td>
                        <td>485</td>
                        <td>91</td>
                        <td>8</td>
                        <td>98</td>
                        <td>312</td>
                        <td>373</td>
                        <td>6</td>
                        <td>352</td>
                        <td>32</td>
                        <td>12</td>
                        <td>2</td>
                        <td>.301</td>
                        <td>.432</td>
                        <td>.550</td>
                        <td>.981</td>
                        <td>---</td>
                        <td>.292</td>
                        <td>.406</td>
                        <td>.517</td>
                        <td>.923</td>
                        <td>3.0</td>
                    </tr>
                </tbody>
            </Table> */}
        </div>
    );
}
